<template>
  <div id="main-wrapper">
    <div v-if="store.trans_id && store.trans_id_type == 'CHANGE LEVERAGE'">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-center">
                <p>{{$t('account.request_change_laverage')}} {{form.account_id}} {{$t('account.from')}} {{form.currentLeverage}} {{$t('account.to')}} {{form.leverage}}.{{$t('account.confirm_mail_id')}}.</p>
              </div>
              <SuccessBox
                    type="leverage"
                  />
              <!-- <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="resetAndBack">OK </a>
              </div> -->
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="resetAndBack">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="message">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-center">
                <p v-if="msgType == 'success'">{{$t('account.leverage_successfully_change')}}</p>
                <p v-else>{{message}}</p>
              </div>
              <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="message = ''">{{$t('account.ok')}} </a>
              </div>
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="message = ''">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="content-container profile-page support-page add-label">
      <div class="page-wrap">
        <div class="page-content clearfix">
          <div class="main-content f-left">
            <div class="title-holder">
              <h4>{{$t('account.change_account_leverage')}}</h4>
            </div>
            <div class="content-holder">
              <div class="row-sec">
                <div class="form-holder wow fadeInLeft colu">
                  <!-- <SuccessBox
                    v-if="
                      store.trans_id && store.trans_id_type == 'CHANGE LEVERAGE'
                    "
                    type="leverage"
                  /> -->
                  <Form @submit="submit">
                    <ul class="clearfix">
                      <li>
                        <label for="">{{$t('account.trading_account')}}</label>
                        <Field
                          class="form-control"
                          as="select"
                          name="account"
                          rules="required"
                          v-model="form.account_id"
                          @change="setLeverage"
                        >
                          <option value="" disabled>
                            {{$t('account.select_trading_account')}}
                          </option>
                          <!-- <option
                            v-for="account of store.tradingAccounts.records"
                            :value="account.account_id"
                            :key="account.account_id"
                          >
                            {{ account.account_id }} ({{
                              account.demo_live == "1" ? "Live" : "Demo"
                            }})
                          </option> -->
                          <optgroup label="Demo MT4">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('0','MT4')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Demo MT5">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('0','MT5')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live MT4">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT4')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live MT5">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT5')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live ZTP">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','ZTP')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                        </Field>
                        <ErrorMessage name="account" />
                      </li>
                      <li>
                        <label for="">{{$t('account.existing_leverage')}}</label>
                        <Field
                          :disabled="true"
                          class="form-control"
                          name="currentLeverage"
                          v-model="form.currentLeverage"
                        />
                        <ErrorMessage name="currentLeverage" />
                      </li>
                      <li>
                        <label for="">{{$t('account.new_leverage')}}</label>
                        <Field
                          class="form-control"
                          as="select"
                          name="leverage"
                          rules="required"
                          v-model="form.leverage"
                        >
                          <option value="" disabled>{{$t('account.select_new_leverage')}}</option>
                          <option
                            v-for="leverage of availableLeverages"
                            :value="leverage.value"
                            :key="leverage.value"
                          >
                            {{ leverage.label }}
                          </option>
                        </Field>
                        <ErrorMessage name="leverage" />
                      </li>
                    </ul>
                    <!-- <br /><br />
                    <ul class="clearfix">
                      <li>
                        <label for="">Select New Leverage</label>
                        <div class="radio">
                          <input type="radio" name="r1" value="" />
                          <span> <p>1:100</p> </span>
                        </div>
                        <div class="radio">
                          <input type="radio" name="r1" value="" />
                          <span class=""> <p>1:200</p> </span>
                        </div>
                        <div class="radio">
                          <input type="radio" name="r1" value="" />
                          <span> <p>1:400</p> </span>
                        </div>
                        <div class="radio">
                          <input type="radio" name="r1" value="" />
                          <span> <p>1:500</p> </span>
                        </div>
                      </li>
                    </ul> -->
                    <div class="btn-holder t-center">
                      <button
                        type="submit"
                        class="btn btn-yellow popup-link-holder"
                      >
                      {{$t('account.change_leverage')}}
                      </button>
                      <button
                        type="button"
                        @click="$router.back()"
                        class="btn btn-blue"
                      >
                      {{$t('account.cancel')}}
                      </button>
                    </div>

                    <div class="not">
                      <p>{{$t('account.account_leverage_reduced')}}</p>
                    </div>
                  </Form>
                </div>
                <div class="img-holder t-center colu wow fadeInRight">
                  <img src="assets/images/change-lev.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";
import SuccessBox from "@/components/shared/SuccessBox";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      form: {
        account_id: "",
        act_account_id: "",
        currentLeverage: "",
        leverage: "",
        operation: "CHANGE LEVERAGE",
      },
      availableLeverages: [],
      message :'',
      msgType :''

    };
  },
  mounted() {
    this.form.account_id = this.store.lastSelectedAccount.account_id;
    this.form.currentLeverage = this.store.lastSelectedAccount.leverage;
    this.availableLeverages = this.static_vars.leverages.filter(
      (i) => i.value != this.store.lastSelectedAccount.leverage
    );
  },
  components: {
    Form,
    Field,
    ErrorMessage,
    SuccessBox,
  },
  methods: {
    MergeAcc(acc_type,platform){
        let demoMT4 = this.store.tradingAccounts.records.filter(i => i.demo_live == acc_type && i.platform == platform).map(val => val)
        return demoMT4 || []
    },
    resetAndBack() {
      this.store.$patch({ trans_id: null });
      this.$router.back();
    },
    setLeverage(e) {
      const account = this.store.tradingAccounts.records.filter(
        (i) => i.account_id == e.target.value
      );
      this.form.currentLeverage = account[0].leverage;
      this.availableLeverages = this.static_vars.leverages.filter(
        (i) => i.value != account[0].leverage
      );
    },
    submit() {
      this.store.accountOperations(this.form, true);
    },
    resend() {
      let form = {
        trans_id: this.store.trans_id,
      };
      this.store.resendOperationsLink(form, true);
    },
    verify() {
      let form = {
        type: this.form.operation,
        google_token: this.google_token,
        trans_id: `${this.store.trans_id}`,
      };
      this.store.verifyAccountOperation(form, true).then(response => {
        //modal show
        this.store.$patch({ trans_id: null });
        this.message = response
        this.msgType = 'success'
      }).catch(error => {
        this.store.$patch({ trans_id: null });
        this.message = error
        this.msgType = 'error'
      });
    },
  },
};
</script>
